import { Flex, Link, Text } from '@chakra-ui/react';

interface IGenericInfoProps {
  date: string;
  href?: string;
  showMoreLabel: string;
  title: string;
}

export const GenericInfo: React.FC<IGenericInfoProps> = ({
  date,
  href,
  showMoreLabel,
  title,
}): JSX.Element => {
  return (
    <Flex direction="column" gap={2} order={{ base: 2, md: 0 }}>
      <Text fontSize={{ base: '20px', md: 'h3.md' }}>{title}</Text>
      <Text>{date} </Text>
      {href && (
        <Link color="brand.red.light" href={href}>
          {showMoreLabel}
        </Link>
      )}
    </Flex>
  );
};
